import { NgModule } from '@angular/core';
import {ArticleWarningModule} from '../../../article/warning/article-warning.module';
import {NgbModalModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {OfferCreateComponent} from './offer-create.component';
import {SharedModule} from '../../../../core/shared.module';
import {UIRouterModule} from '@uirouter/angular';
import {WorkflowPipesModule} from '../../pipes/workflow-pipes.module';
import {
  PositionMissingGoldPriceModule
} from '../../position-missing-gold-price/workflow-position-missing-gold-price.module';
import {EvStatusLabelComponent} from '../../../../common/ev-status-label/ev-status-label.component';

@NgModule({
  declarations: [
    OfferCreateComponent,
  ],
  imports: [
    SharedModule,
    UIRouterModule.forChild(),
    ArticleWarningModule,
    NgbModalModule,
    NgbTooltipModule,
    WorkflowPipesModule,
    PositionMissingGoldPriceModule,
    EvStatusLabelComponent,
  ],
})
export class OfferCreateModule { }
